<template>
    <div class="form">
        <Form ref="info" :model="info" :label-width="100">
            <fieldset disabled style="border: none">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="姓名" prop="nickName">
                            <Input v-model="info.nickName" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="手机号" prop="mobile">
                            <Input v-model="info.mobile" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="微信昵称" prop="wxNickName">
                            <Input v-model="info.wxNickName" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="微信头像" prop="avatarUrl">
                            <base-img height="30" width="30" :src="info.avatarUrl"></base-img>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="充值单号" prop="rechargeNo">
                            <Input v-model="info.rechargeNo" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="充值金额" prop="rechargeAmount">
                            <input-number v-model="info.rechargeAmount" placeholder>
                                <span slot="append">元</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="赠送金额" prop="sendAmount">
                            <Input v-model="info.sendAmount" :maxlength="256" placeholder>
                                <span slot="append">元</span>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="实付金额" prop="payAmount">
                            <input-number v-model="info.payAmount" placeholder>
                                <span slot="append">元</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="支付方式" prop="sex">
                            <Select v-model="info.payType" transfer placeholder disabled>
                                <Option
                                    v-for="(item, index) in dict.payType.toList()"
                                    :value="item.id"
                                    :key="index"
                                >{{ item.text }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="充值时间" prop="createTime">
                            <DatePicker
                                v-model="info.createTime"
                                transfer
                                style="width: 100%;"
                                type="datetime"
                                disabled
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="工作单位" prop="workUnit">
                            <Input v-model="info.workUnit" :maxlength="128" placeholder></Input>
                        </FormItem>
                    </Col>
                </Row>
            </fieldset>
        </Form>
    </div>
</template>
<script>
import { mInfoRechargeList,mInfoRechargeView } from "@/api/member";
import Dict from "_u/dict";
import { ymdL, toDate } from "_u/helper";
import BaseImg from "_c/base-img";

export default {
    name: "m-recharge-form",

    props: {
        id: {
            type: [String, Number],
            default: "",
        },
    },

    components: {},

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                nickName: "", // 姓名
                mobile: "", // 手机号
                wxNickName: "", // 微信昵称
                avatarUrl: "", // 微信头像
                rechargeNo: "", // 充值单号
                rechargeAmount: "", // 充值金额
                sendAmount: "", //赠送金额
                payAmount: "", // 实付金额
                payType: "", // 支付方式
                createTime: "", // 充值时间
                workUnit: "", // 工作单位
                ver: "", // 版本号
            },

            dict: {
                payType: Dict.NULL,
            },
        };
    },

    computed: {},

    methods: {
        fetch() {
            return mInfoRechargeView(this.id);
        },
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([Dict.get(["pay_type"]), this.fetch()])
                .then((args) => {
                    var [dictGroup, view] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    if (view) {
                        var viewData = view.data.entity;
                        if(viewData.rechargeStatus=="1"){
                            viewData.createTime = ""
                        }else{
                            viewData.createTime = ymdL(viewData.createTime);
                        }
                        // 实体数据
                        
                        viewData.payAmount /= 100;
                        viewData.rechargeAmount /= 100;
                        viewData.sendAmount /= 100;
                        console.log(viewData);
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        );
                    }
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>
<style lang="less" scoped></style>
